<template>
  <div>
    <div v-show="cmsContent">
      <lv-cms :content="cmsContent" version2 />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import { LvCms } from '~~/common/components/loginet-vue-shop/index';
  import { usePromotionStore } from '~~/shop/app/stores/promotion';
  import { useDeliveryStore } from '~~/shop/app/stores/delivery';

  export default {
    name: 'AwContentSeoText',
    components: {
      LvCms,
    },
    props: {
      contentId: {
        required: true,
        type: [Number, String],
      },
    },
    computed: {
      ...mapState(usePromotionStore, {
        contentSeoTextTranslation (state) {
          return state.contentSeoText[this.contentId];
        },
      }),
      ...mapState(useDeliveryStore, {
        deliverySetup: state => state.setup,
      }),
      cmsContent () {
        return this.contentSeoTextTranslation?.body || '';
      },
    },
    watch: {
      contentId: {
        immediate: true,
        handler (newVal) {
          const promotionStore = usePromotionStore();
          promotionStore.fetchContentSeoText({ id: newVal });
        },
      },
      deliverySetup () {
        const promotionStore = usePromotionStore();
        promotionStore.fetchContentSeoText({ id: this.contentId });
      },
    },
  };
</script>
